module.exports = __webpack_public_path__ + "img/gzh-code.9381483e.png";